import axios from "axios";
import React, { Component } from "react";
import { getPlayerApiUrl } from "./apiUrlBuilder";
import { toast } from "react-toastify";
import { login } from "./auth";

const apiUrl = `${getPlayerApiUrl()}`;

class PlayerLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      phase: 0,
      isWait: false,
      authData: { phoneNumber: "", verificationCode: "" },
    };
  }

  handleAuthChange = (e) => {
    const authData = { ...this.state.authData };
    authData[e.currentTarget.id] = e.currentTarget.value;
    this.setState({ authData });
  };

  find = async (e) => {
    if (e !== undefined) e.preventDefault();

    const { status } = await axios.post(`${apiUrl}/find`, {
      phone: this.state.authData.phoneNumber,
    });

    if (status === 200) {
      this.setState({ phase: 1 });
    }
  };

  login = async (e) => {
    e.preventDefault();

    const { data, status } = await axios.post(`${apiUrl}/login`, {
      phone: this.state.authData.phoneNumber,
      token: this.state.authData.verificationCode,
    });

    if (status === 200) {
      login(data.sessionId, data.isAdmin, data.myPage, data.tag, data.permissions);
    } else {
      toast.error("Unable to sign in with provided verification code, please try again");
      this.setState({
        phase: 0,
        authData: { phoneNumber: "", verificationCode: "" },
      });
    }
  };

  render() {
    const phasePhoneNumber = 0;
    const phaseVerificationCode = 1;

    return (
      <React.Fragment>
        <h1>Sign In</h1>
        <div className="container-sm">
          {this.state.phase === phasePhoneNumber && (
            <form onSubmit={this.find}>
              <div className="mb-3">
                <label htmlFor="phoneNumber" className="form-label">
                  Phone number
                </label>
                <input
                  type="phone"
                  required
                  className="form-control"
                  id="phoneNumber"
                  value={this.state.authData.phoneNumber}
                  aria-describedby="phoneNumberHelp"
                  onChange={(e) => this.handleAuthChange(e)}
                />
                <div className="invalid-feedback">Please enter a valid phone number</div>
                <div id="phoneNumberHelp" className="form-text">
                  Please enter as 07123456789: 07 followed by 9 digits
                </div>
              </div>
              <button type="submit" className="btn btn-primary btn-lg">
                Continue
              </button>
            </form>
          )}
          {this.state.phase === phaseVerificationCode && (
            <form onSubmit={this.login}>
              <div className="mb-3">
                <label className="form-label">A verification code has been sent to {this.state.authData.phoneNumber} via text, please enter it below:</label>
              </div>
              <div className="mb-3">
                <label htmlFor="verificationCode" className="form-label">
                  Verification code
                </label>
                <input
                  type="text"
                  required
                  className="form-control"
                  id="verificationCode"
                  value={this.state.authData.verificationCode}
                  aria-describedby="verificationCodeHelp"
                  onChange={(e) => this.handleAuthChange(e)}
                />
                <div id="verificationCodeHelp" className="form-text">
                  Please enter 6 digits without spaces
                </div>
              </div>
              <button type="button" className="btn btn-secondary btn-lg me-1 mt-1" onClick={() => this.setState({ phase: 0 })}>
                Back
              </button>
              <button type="button" className="btn btn-secondary btn-lg me-3 mt-1" onClick={() => this.find()}>
                Resend code
              </button>
              <button type="submit" className="btn btn-primary btn-lg mt-1">
                Continue
              </button>
            </form>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default PlayerLogin;
